import React from 'react';

/**
 * Explicit empty state for the users list (no rows match the current filters).
 * Props: { hasFilters, onClear }
 */
const EmptyState = ({ hasFilters, onClear }) => (
  <div className="uv-state" data-testid="users-empty">
    <div className="uv-state__icon" aria-hidden="true">🔍</div>
    <p className="uv-state__title">No users found</p>
    <p className="uv-state__msg">
      {hasFilters
        ? 'No users match the current filters. Try adjusting or clearing them.'
        : 'There are no users to show yet.'}
    </p>
    {hasFilters && onClear ? (
      <button type="button" className="uv-state__btn" onClick={onClear}>Clear filters</button>
    ) : null}
  </div>
);

export default EmptyState;
